// extracted by mini-css-extract-plugin
export var container = "_24-0";